import { styled } from "styled-components";

import { colorCSS, fontSizes } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const WebinarLink = styled.a<{ appearance?: string }>`
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("background", `${colorCSS("B400")}`)}
    ${redundantCssFromKebab("border-radius", "6px")}
    ${redundantCssFromKebab("box-shadow", `0 2px 0 ${colorCSS("B500")}`)}
    ${redundantCssFromKebab("color", `${colorCSS("N0")}`)}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("height", "100%")}
    ${redundantCssFromKebab("min-height", "6rem")}
    ${redundantCssFromKebab("opacity", "1")}
    ${redundantCssFromKebab("padding", "0.5rem 1rem 0.5rem 6rem")}
    ${redundantCssFromKebab("position", "relative")}
    ${redundantCssFromKebab("text-align", "left")}
    ${redundantCssFromKebab("text-decoration", "none")}
    ${redundantCssFromKebab("transition", "all 0.2s ease 0s")}

    /*text*/
    span {
        ${redundantCssFromKebab("display", "inline-block")}
        ${redundantCssFromKebab("font-size", `${fontSizes.md}`)}
        ${redundantCssFromKebab("font-weight", "500")}
        ${redundantCssFromKebab("line-height", "1.2")}
    }

    /*play button circle*/
    &::before {
        ${redundantCssFromKebab("border", "3px solid white")}
        ${redundantCssFromKebab("border-radius", "50%")}
        ${redundantCssFromKebab("content", '""')}
        ${redundantCssFromKebab("height", "4rem")}
        ${redundantCssFromKebab("left", "1rem")}
        ${redundantCssFromKebab("margin-top", "-2rem")}
        ${redundantCssFromKebab("position", "absolute")}
        ${redundantCssFromKebab("top", "50%")}
        ${redundantCssFromKebab("width", "4rem")}
    }

    /*play button arrow*/
    &::after {
        ${redundantCssFromKebab("border", "1rem solid transparent")}
        ${redundantCssFromKebab("border-left", "1.5rem solid white")}
        ${redundantCssFromKebab("border-right", "0")}
        ${redundantCssFromKebab("content", '""')}
        ${redundantCssFromKebab("height", "0")}
        ${redundantCssFromKebab("left", "2.5rem")}
        ${redundantCssFromKebab("margin-top", "-1rem")}
        ${redundantCssFromKebab("position", "absolute")}
        ${redundantCssFromKebab("top", "50%")}
        ${redundantCssFromKebab("width", "0")}
    }

    &:hover {
        ${redundantCssFromKebab("color", `${colorCSS("N0")}`)}
        ${redundantCssFromKebab("text-decoration", "none")}
        ${redundantCssFromKebab("transform", "translateY(-2px)")}
    }

    ${({ appearance }) =>
        appearance === "Webinars page" &&
        `
      background: ${colorCSS("P100", 0.5)};
      box-shadow: none;

      &::before {
        background: ${colorCSS("N0")};
      }

      &::after {
        border-left-color: ${colorCSS("P100", 0.5)};
      }

      &:hover {
        background: ${colorCSS("P200", 0.75)};
        &::after {
          border-left-color: ${colorCSS("P200", 0.75)};
        }
      }
    `}
`;
